<template>
  <DashboardLayout>
    <template #top-left>
      <WindChartCard v-bind="config.topLeft" />
    </template>
    <template #top-right>
      <WindChartCard v-bind="config.topRight" />
    </template>
    <template #bottom-left>
      <WindChartCard v-bind="config.bottomLeft" />
    </template>
    <template #bottom-right>
      <WindChartCard v-bind="config.bottomRight" />
    </template>
  </DashboardLayout>
</template>

<script>
import DashboardLayout from '@/components/dashboard/DashboardLayout.vue'
import WindChartCard from '@/components/dashboard/WindChartCard.vue'
import { DASHBOARD_CONFIGS } from '@/components/dashboard/dashboardConfig.js'

export default {
  name: 'DashboardPage2',
  components: {
    DashboardLayout,
    WindChartCard
  },
  computed: {
    config() {
      return DASHBOARD_CONFIGS.page2
    }
  }
}
</script>
